import { Navigate } from "react-router-dom";
import { useAuth, hasRole } from "@/lib/auth";

const ROLE_LANDING = {
  admin: "/dashboard",
  sales: "/quotes",
  accounting: "/cari",
  warehouse: "/products",
  viewer: "/reports/stock",
};

export default function RequireRole({ roles, children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !hasRole(user, ...roles)) {
    return <Navigate to={ROLE_LANDING[user.role] || "/"} replace />;
  }
  return children;
}
